import React from 'react'

import { HiPlus } from 'react-icons/hi'

import { pick } from '@styled-system/props'

import { Icon, Text } from 'Components/UI'

import { iconChatGlyph, iconGearGlyph } from 'Assets/_Legacy/CtoPage'

import { Container, PlusIconHolder } from './styles'

const BADGE_KIND = { business: 'business', technical: 'technical' }

function Badge({ kind = BADGE_KIND.business, text = '', ...rest }) {
  return (
    <Container {...pick(rest)}>
      <PlusIconHolder right={kind === BADGE_KIND.business}>
        <HiPlus size={36} />
      </PlusIconHolder>

      <Icon
        glyph={kind === BADGE_KIND.technical ? iconGearGlyph : iconChatGlyph}
      />

      <Text
        fontSize={[12, 12, 14, 14, 14, 14, 24]}
        ml={[2, 2, 2, 2, 2, 2, 7]}
        nowrap
      >
        {text}
      </Text>
    </Container>
  )
}

Badge.kind = BADGE_KIND

export default Badge
